import React from "react";

const DrawerLoading = ({ label = "" }) => {
  return (
    <div className="absolute top-0 bottom-0 right-0 left-0 bg-white z-10 opacity-80 flex flex-col gap-2 items-center justify-center h-full">
      <span className="loader-syncx"></span>
      {label && <div className="font-semibold">{label}</div>}
    </div>
  );
};

export default DrawerLoading;
